import { useQuery } from "@tanstack/react-query";
import { getPrescriptions } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";

export function usePrescriptions({
  enabled = true,
  mobileNumber,
  patientName,
  professionalId,
}: {
  enabled?: boolean;
  mobileNumber: string | null | undefined;
  patientName: string | null | undefined;
  professionalId: string | undefined;
}) {
  const { toast } = useToast();

  const {
    data: prescriptions,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["prescriptions", mobileNumber, patientName],
    queryFn: () => getPrescriptions(patientName, mobileNumber, professionalId),
    enabled: enabled && !!mobileNumber && !!patientName && !!professionalId,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch doctor prescriptions",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return { prescriptions, isLoading, isFetched };
}
